import { render, staticRenderFns } from "./imgX.vue?vue&type=template&id=782f3671&scoped=true"
var script = {}
import style0 from "./imgX.vue?vue&type=style&index=0&id=782f3671&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f3671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782f3671')) {
      api.createRecord('782f3671', component.options)
    } else {
      api.reload('782f3671', component.options)
    }
    module.hot.accept("./imgX.vue?vue&type=template&id=782f3671&scoped=true", function () {
      api.rerender('782f3671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgX.vue"
export default component.exports